// app/global-error.tsx
'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    // This is the app's only error boundary — there is no error.tsx anywhere in src/, so
    // every uncaught render error lands here and nothing exists above it to catch a
    // failure in this component. Telemetry must never be able to take the recovery UI
    // down with it. Note this call is NOT redundant with capture_exceptions: Next
    // overrides React's default error handlers, so boundary-caught errors never reach
    // the automatic window.onerror path.
    try {
      // digest is the only handle for correlating this crash with server-side logs.
      posthog.captureException(error, { digest: error.digest });
    } catch {
      // Reporting is best-effort. Rendering the fallback is not.
    }
  }, [error]);

  return (
    <html>
      <body>
        <h2>Something went wrong.</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  );
}
